import { CacheableDataObject } from './CacheableDataObject';
import { Season } from './Season';
import { DateFormat } from "../components/DateFormat";

class League extends CacheableDataObject {
	static unrankedProps = {
		tier_rank: 1,
		is_unranked: true,
		image_url: null
	};

	beforeConstruct(data) {
		this.image_url = `${siteUrl}/images/smash/tiers/bronze.png`;
	}

	static createUnranked() {
		return League.create(League.unrankedProps);
	}

	static divisionNumberToRomanNumeral(divisionNumber) {
		switch(divisionNumber) {
			case 1:
				return 'I';
			case 2:
				return 'II';
			case 3:
				return 'III';
		}
		return '>:(';
	}

	meetsRankedRequirements() {
		if(!this.season || !this.stats) {
			return false;
		}
		return this.stats.ranked_played >= this.season.games_required_for_ladder &&
			this.stats.unique_opponents >= this.season.opponents_required_for_ladder;
	}

	isEqualTo(otherLeague) {
		if(!otherLeague) {
			return false;
		}
		return this.tier_rank == otherLeague.tier_rank;
	}

	isGreaterOrEqualTo(otherLeague) {
		if(!otherLeague) {
			// alert('There was an error, you should contact anther');
			return false;
		}
		return this.tier_rank >= otherLeague.tier_rank;
	}

	isLessOrEqualTo(otherLeague) {
		if(!otherLeague) {
			// alert('There was an error, you should contact anther');
			return true;
		}
		return this.tier_rank <= otherLeague.tier_rank;
	}

	hasPlayed() {
		if(!this.season || !this.stats) {
			return false;
		}
		return this.stats.ranked_played || this.stats.unique_opponents;
	}

	isUnranked() {
		return this.is_unranked || this.tier_rank === 1 || this.name === 'Unranked';
	}

	isRanked() {
		return !this.isUnranked();
	}

	getUnrankedClassName() {
		if(!this.isUnranked()) {
			return '';
		}
		return 'tier_ladder_league_unranked';
	}

	getClassName() {
		let string = 'Ladder_League_';
		if(this.name) {
			string += this.name.replace(/ /g, '_');

		}
		else {
			string += 'Unranked';
		}
		return string;
	}

}

League.prototype.dataLocationParsers = {
	season: (object, data) => {
		if(data.season.id) {
			object.season = Season.retrieve(data.season);
		}
	},
	when: (object, data) => {
		object.when = DateFormat.momentFromLadderTime(data.when);
	},
	image_url: (object, data) => {
		if(data.image_url === null) {
			object.image_url = `${siteUrl}/images/smash/tiers/bronze.png`;
		}
		else {
			object.image_url = data.image_url;
		}
	},
	division_number: (object, data) => {
		object.division_number = data.division_number ? Number.parseInt(data.division_number) : null;
		object.division = object.division_number ? League.divisionNumberToRomanNumeral(object.division_number) : null;
	}
};


export { League };